<div class="separator-widget">
  <div [classList]="getClasses()"></div>
</div>
